// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"99848402","410":"ec65079a"}[chunkId] + ".chunk.css";
};